export const CLASS_ROOT = 'idsk-button';

/** Available button variants. */
export const buttonVariants = ['primary', 'secondary', 'warning', 'search'] as const
